import { Children } from 'react';
import useCurrentSubscriptionType from '@/v2/domains/Subscriptions/hooks/useCurrentSubscriptionType.hook';
import { subscriptionTypes } from '@rockalingua/shared/subscriptions/constants';

export default function SubscriptionGuard({ children, skeleton = null }) {
  const { subscriptionType, isLoading } = useCurrentSubscriptionType();

  if (isLoading) {
    return skeleton;
  }

  const childrenArray = Children.toArray(children);

  const matchingChild = childrenArray.find((child) => {
    return child.type?.subscriptionCase === subscriptionType?.code;
  });

  const defaultChild = childrenArray.find(
    (child) => child.type?.subscriptionCase === 'default'
  );

  return matchingChild || defaultChild || null;
}

function createSlotComponent(subscriptionCase) {
  function SlotComponent({ children }) {
    return children;
  }
  SlotComponent.subscriptionCase = subscriptionCase;
  return SlotComponent;
}

SubscriptionGuard.TeacherPro = createSlotComponent(
  subscriptionTypes.teacherPro.code
);
SubscriptionGuard.Teacher = createSlotComponent(subscriptionTypes.teacher.code);
SubscriptionGuard.Family = createSlotComponent(subscriptionTypes.family.code);
SubscriptionGuard.Default = createSlotComponent('default');
